import { render, staticRenderFns } from "./PublicSeaClueAssign.vue?vue&type=template&id=963c17f8&scoped=true"
import script from "./PublicSeaClueAssign.vue?vue&type=script&lang=js"
export * from "./PublicSeaClueAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963c17f8",
  null
  
)

export default component.exports